<template>
  <div class="visualization">
  <b-overlay :show="this.expiredTrial" rounded="sm" no-center>

    <Error></Error>
    <GraphVisualization></GraphVisualization>
    <template #overlay>
      <div class="text-center">
        <b-icon icon="lock" font-scale="3" animation="cylon" class="mb-3 mt-5"></b-icon>
        <h2 id="cancel-label">Your trial account has expired. <br>Register for a <a href="https://www.sci-fund.ai/plans-and-prices" target="_blank">full membership</a> or <a href="mailto:info@sci-fund.ai?subject=sci-fund%20Account">get in touch</a>.</h2>

      </div>
    </template>
  </b-overlay>
  </div>
</template>

<script>
  import GraphVisualization from '@/components/GraphVisualization'
  import Error from '@/components/Error'

  export default {
    name: 'visualization',
    components: {
      Error,
      GraphVisualization
    },
    computed: {
      expiredTrial() {
        if (this.$store.state ) {
          return this.$store.state.expiredTrial;
        }
        return false;
      },

    }
  }
</script>

<style src="vue-d3-network/dist/vue-d3-network.css"></style>

<style type="scss">
  .node{
    stroke:#2d97ba;
    fill:#032F3C;
  }
  .node.selected{
    stroke:#be385d;
    stroke-width:5px
  }
  .node.pinned{
    //stroke:#ffffff;
    stroke-width:5px
  }
  .link, .link:hover{
    stroke:#d5eaf1;
  }
  .node:hover{
    stroke:#be385d
  }
  .link.selected{
    stroke:#be385d
  }
  .link-label,.node-label{
    fill:#1e647c;
    font-weight: 600;
    //fill:#ffffff;
  }
  .svgcontainer {
    width: 100%;
    //height: 90vh;
  }
</style>
